import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import TabMenu from '../../../components/base/TabMenu/TabMenu';

export default function CollageModal(props) {
  const { handleClose = () => {}, session } = props;
  const [values, setValues] = useState(0);
  const intl = useIntl();
  const { formatMessage } = intl;
  return (
    <Dialog
      className="collage-modal"
      size="xl"
      open
      onClose={handleClose}
    >
      <DialogTitle header={formatMessage({ id: 'collages' })} title={<Icons onClick={handleClose} customIcon icon="close" className="close" />} />
      <DialogContent>
        <div className="collage-wrapper custom-scroll-theme">
          <TabMenu
            className="collage-selector"
            selectedTab={values}
            onSelectOptions={item => setValues(item.value)}
            options={[
              { value: 0, label: formatMessage({ id: 'collage.1' }) },
              { value: 1, label: formatMessage({ id: 'collage.2' }) },
              { value: 2, label: formatMessage({ id: 'collage.3' }) },
            ]}
          />
          <div className="violation-name">
            <span className="violation-type">{formatMessage({ id: 'violation' })}:</span>
            <span>{formatMessage({ id: 'violation.type.401' })}</span>
          </div>
          <div className="collage-image-wrapper">
            <img className="collage-image" src={`${process.env.PUBLIC_URL}/mock/camera-mock.png`} alt="img" />
          </div>
        </div>
      </DialogContent>
      <DialogFooter>
        <Button onClick={() => handleClose()}>{formatMessage({ id: 'app.download' })}</Button>
        <Button variant="secondary" onClick={() => handleClose()}>{formatMessage({ id: 'app.close' })}</Button>
      </DialogFooter>
    </Dialog>
  );
}
